<template>
    <v-menu
        v-model="metaMenuVisibility"
        bottom
        left
        offset-y
        max-width="500"
        :close-on-content-click="false"
    >
        <template v-slot:activator="{ on }">
            <icon-button
                icon="SlidersHorizontal"
                :on="on"
            />
        </template>
        <v-card class="px-4 py-2 pt-4">
            <v-container>
                <v-row no-gutters align="baseline" class="pb-3">
                    <v-col cols="6" class="pr-2">
                        <ComboboxDropdown
                            :items="articles"
                            :selected="selected_article"
                            name-key="info"
                            value-key="id"
                            :sort="false"
                            show-selected-first
                            deselect
                            :label="$t('Article')"
                            @input="on_article_change"
                        />
                    </v-col>
                    <v-col cols="6">
                        <ComboboxDropdown
                            :items="billing_projects"
                            :selected="selected_billing_project"
                            name-key="info"
                            value-key="id"
                            :sort="false"
                            show-selected-first
                            deselect
                            :label="$t('Project')"
                            @input="on_billing_project_change"
                        />
                    </v-col>

                    <v-col cols="6" class="pr-2">
                        <ComboboxDropdown
                            :items="resources"
                            :selected="selected_resource"
                            name-key="info"
                            value-key="id"
                            :sort="false"
                            show-selected-first
                            deselect
                            :label="$t('Resource')"
                            @input="on_resource_change"
                        />
                    </v-col>
                    <v-col cols="6" class="pr-2">
                        <ComboboxDropdown
                            :items="cost_centers"
                            :selected="selected_cost_center"
                            name-key="info"
                            value-key="id"
                            :sort="false"
                            show-selected-first
                            deselect
                            :label="$t('Cost center')"
                            @input="on_cost_center_change"
                        />
                    </v-col>

                    <v-col cols="6" class="pr-2">
                        <v-text-field
                            v-model="item.ext_variable"
                            outlined
                            maxlength="50"
                            hide-details
                            deselect
                            :label="$t('Custom Value')"
                            @input="on_ext_variable_change"
                        />
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions>
                <v-btn
                    left
                    color="primary"
                    class="ml-auto"
                    @click="metaMenuVisibility=false"
                >
                    {{ $t("Save") }}
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-menu>
</template>

<script>
import {$t} from "../../i18n";
import {computed, ref} from "@vue/composition-api";
import ComboboxDropdown from "../../components/ComboboxDropdown.vue";
import ProductFieldModule from "../../store/modules/product_field";
import ProductModule from "../../store/modules/product";
import RightsModule from "../../composables/use-rights";

export default {
    name: "SalesInvoiceEditRowOptions",
    components: {
        ComboboxDropdown
    },
    props: {
        item: {
            type: Object,
            default: null
        },
        accountId: {
            type: Number,
            default: null
        },
        isInvoice: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const {
            get_account_articles,
            get_account_resources,
            get_account_billing_projects,
            get_account_cost_centers,
        } = ProductFieldModule();
        const {can_edit_account} = RightsModule();
        const metaMenuVisibility = ref(false);

        const {products} = ProductModule();
        const product = computed(() => products.value.find(x => x.id === props.item.product_id))

        const articles = computed(() => get_account_articles(props.accountId).value);
        const resources = computed(() => get_account_resources(props.accountId).value);
        const billing_projects = computed(() => get_account_billing_projects(props.accountId).value);
        const cost_centers = computed(() => get_account_cost_centers(props.accountId).value);

        const selected_article = computed(() => articles.value.filter(x => x.id === props.item.article_id))
        const selected_resource = computed(() => resources.value.filter(x => x.id === props.item.resource_id))
        const selected_billing_project = computed(() => billing_projects.value.filter(x => x.id === props.item.billing_project_id))
        const selected_cost_center = computed(() => cost_centers.value.filter(x => x.id === props.item.cost_center_id))

        const on_article_change = (e) => {
            props.item.article_id = e.id
            ctx.emit('change')
        }
        const on_resource_change = (e) => {
            props.item.resource_id = e.id
            ctx.emit('change')
        }
        const on_billing_project_change = (e) => {
            props.item.billing_project_id = e.id
            ctx.emit('change')
        }
        const on_cost_center_change = (e) => {
            props.item.cost_center_id = e.id
            ctx.emit('change')
        }
        const on_ext_variable_change = (e) => {
            ctx.emit('change')
        }

        return {
            can_edit_account,
            metaMenuVisibility,

            product,

            products,
            articles,
            resources,
            billing_projects,
            cost_centers,

            on_article_change,
            on_resource_change,
            on_billing_project_change,
            on_cost_center_change,
            on_ext_variable_change,

            selected_article,
            selected_resource,
            selected_billing_project,
            selected_cost_center,
        }
    }
}
</script>
